import Marquee from "react-fast-marquee";

const words = [
  "Vogue", "Campaigns", "Runway", "Editorial", "Ambassador",
  "Brand Deals", "Portfolio", "Milan", "Paris", "New York",
  "Booked & Busy", "Front Cover",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="py-10 md:py-14 bg-[#0a0a0a] border-y border-white/20 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="marquee-item flex items-center gap-12">
            <span className="font-display italic font-light text-4xl md:text-6xl text-[#ffffff]/50">
              {w}
            </span>
            <span className="text-[#ffffff] text-2xl">&#10022;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
